import { api } from "./api";
import { decimalUnits, orderStates, type Order, type OrderState } from "./procurement";

export const serviceUnitLabels = { sat: "sat", dan: "dan", tura: "tura", pausal: "paušal" } as const;
export type ServiceUnit = keyof typeof serviceUnitLabels;
export interface ServiceTypeInput { naziv: string; aktivan: boolean; redoslijed: number; konto: string | null }
export interface ServiceType extends ServiceTypeInput { id: string }
export interface ServiceInput { vrsta_usluge_id: string; termin_od: string; termin_do: string; nacin_obracuna: ServiceUnit }
export interface ServiceDetails extends ServiceInput {
  id?: string; narudzba_id?: string; vrsta_usluge: string; procjena_kolicine: string;
  potvrdeno_kolicine: string; potvrdeni_dani: string[]; danas_upisano: boolean;
}
export interface ExecutionInput { datum: string; kolicina: string; izvodac_osoba: string; napomena: string | null }
export interface ServiceExecution extends ExecutionInput {
  id: string; narudzba_id: string; dokument_id: string | null; potvrdio_id: string; potvrdio: string;
  created_at: string; ponisteno_at: string | null; ponistio_id: string | null; ponisteno_razlog: string | null;
}
const root = "/nabava";
export const serviceProcurement = {
  serviceTypes: async (signal?: AbortSignal) => (await api.get<ServiceType[]>(`${root}/vrste-usluga`, { signal })).data,
  saveServiceType: async (input: ServiceTypeInput, id?: string) => (await (id ? api.put<ServiceType>(`${root}/vrste-usluga/${id}`, input) : api.post<ServiceType>(`${root}/vrste-usluga`, input))).data,
  record: async (id: string, input: ExecutionInput, photo?: File | null) => {
    let payload: ExecutionInput | FormData = input;
    if (photo) { payload = new FormData(); payload.set("podaci", JSON.stringify(input)); payload.set("fotka", photo); }
    return (await api.post<Order>(`${root}/narudzbe/${id}/izvrsenja`, payload)).data;
  },
  reverse: async (id: string, executionId: string, reason: string) => (await api.post<Order>(`${root}/narudzbe/${id}/izvrsenja/${executionId}/ponisti`, { razlog: reason })).data,
  finish: async (id: string) => (await api.post<Order>(`${root}/narudzbe/${id}/zavrsi-uslugu`)).data,
};
export function serviceStateLabel(state: OrderState) {
  return state === "djelomicno_stiglo" ? "U izvršenju" : state === "stiglo" ? "Izvršeno" : orderStates[state];
}
/** Quantity (3 places) × price (2 places), rounded half up to cents. */
export function estimatedServiceAmount(quantity: string, price: string) {
  const count = decimalUnits(quantity, 3), cents = decimalUnits(price);
  if (count === null || cents === null) return "";
  const total = (count * cents + 500n) / 1000n;
  const result = `${total / 100n}.${String(total % 100n).padStart(2, "0")}`;
  return decimalUnits(result) === null ? "" : result;
}
